"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPurchasedSubscriptionDetailsResponse = exports.mapApplicationV2Response = exports.mapApplicationResponse = exports.mapApplicationCategoryResponse = exports.mapApplicationVersionResponse = void 0;
const ResourceClient_1 = require("./ResourceClient");
const urls_1 = __importDefault(require("./urls"));
const mapApplicationVersionResponse = (av) => {
    var _a;
    return ({
        id: av.id,
        name: av.name,
        description: av.description,
        thumbnailUrl: av.thumbnail_url,
        iconUrl: av.icon_url,
        sourceUrl: av.source_url,
        applicationId: av.application_id,
        presentationProperties: av.presentation_properties,
        majorVersion: av.major_version,
        minorVersion: av.minor_version,
        patchVersion: av.patch_version,
        previewResolution: av.preview_resolution,
        previewOrientation: av.preview_orientation,
        strings: av.strings,
        dynamicThumbnails: av.has_dynamic_thumbnails,
        configurableDuration: av.configurable_duration,
        defaultDuration: av.default_duration,
        embeddedUrlFormat: av.embedded_url_format,
        reviewStatus: av.review_status,
        createdAt: av.created_at,
        updatedAt: av.updated_at,
        helperLinkText: av.helper_link_text,
        helperLinkUrl: av.helper_link_url,
        scopes: (_a = av.scopes) !== null && _a !== void 0 ? _a : [],
    });
};
exports.mapApplicationVersionResponse = mapApplicationVersionResponse;
const mapApplicationCategoryResponse = (applicationCategory) => ({
    id: applicationCategory.id,
    name: applicationCategory.name,
    createdAt: applicationCategory.created_at,
    updatedAt: applicationCategory.updated_at,
});
exports.mapApplicationCategoryResponse = mapApplicationCategoryResponse;
const mapApplicationResponse = (a) => ({
    id: a.id,
    applicationCategory: a.application_category
        ? (0, exports.mapApplicationCategoryResponse)(a.application_category)
        : null,
    applicationCategoryId: a.application_category_id,
    currentDeploymentId: a.current_deployment_id,
    currentAppVersion: (0, exports.mapApplicationVersionResponse)(a.current_app_version),
    isDeprecated: a.is_deprecated,
    isMarketplace: a.is_marketplace,
    resource: (0, ResourceClient_1.mapResourceResponse)(a.resource),
    name: a.name,
    websiteUrl: a.website_url,
});
exports.mapApplicationResponse = mapApplicationResponse;
const mapApplicationV2Response = (a) => ({
    id: a.id,
    name: a.name,
    description: a.description,
    isDeprecated: a.is_deprecated,
    isPubliclyAvailable: a.is_publicly_available,
    resourceId: a.resource_id,
    r: {
        resource: (0, ResourceClient_1.mapResourceV2Response)(a.r.resource),
    },
});
exports.mapApplicationV2Response = mapApplicationV2Response;
const mapPurchasedSubscriptionDetailsResponse = (ps) => ({
    quantity: ps.quantity,
    term: ps.term,
    billingTerm: ps.billing_term,
    startDate: ps.start_date,
    transactionId: ps.transaction_id,
});
exports.mapPurchasedSubscriptionDetailsResponse = mapPurchasedSubscriptionDetailsResponse;
const mapGetProductListResponse = (_a) => {
    var { response } = _a, otherValues = __rest(_a, ["response"]);
    return (Object.assign({ response: response === null || response === void 0 ? void 0 : response.map(({ grant_scope, product_list }) => ({
            grantScope: grant_scope,
            productList: product_list === null || product_list === void 0 ? void 0 : product_list.map(({ term, reach_out_to_sales, purchased_subscription_details, purchased_asset_details, product_subscription_type, product_name, product_line, product_id, product_family, product_default_quantity, product_code, product_app_plan, net_price, marketplace_quantity_editable, manual_enablement_required, is_quantity_required, client_facing_pricing, client_facing_plan_description, business_use_case, }) => ({
                term: term,
                reachOutToSales: reach_out_to_sales,
                purchasedSubscriptionDetails: purchased_subscription_details === null || purchased_subscription_details === void 0 ? void 0 : purchased_subscription_details.map((subscription) => (0, exports.mapPurchasedSubscriptionDetailsResponse)(subscription)),
                purchasedAssetDetails: purchased_asset_details === null || purchased_asset_details === void 0 ? void 0 : purchased_asset_details.map((asset) => (0, exports.mapPurchasedSubscriptionDetailsResponse)(asset)),
                productSubscriptionType: product_subscription_type,
                productName: product_name,
                productLine: product_line,
                productId: product_id,
                productFamily: product_family,
                productDefaultQuantity: product_default_quantity,
                productCode: product_code,
                productAppPlan: product_app_plan,
                netPrice: net_price,
                marketplaceQuantityEditable: marketplace_quantity_editable,
                manualEnablementRequired: manual_enablement_required,
                isQuantityRequired: is_quantity_required,
                clientFacingPricing: client_facing_pricing,
                clientFacingPlanDescription: client_facing_plan_description,
                businessUseCase: business_use_case,
            })),
        })) }, otherValues));
};
const mapPurchaseProductResponse = (_a) => {
    var { response } = _a, otherValues = __rest(_a, ["response"]);
    return (Object.assign({ response: {
            quoteId: response === null || response === void 0 ? void 0 : response.quote_id,
            oppId: response === null || response === void 0 ? void 0 : response.opp_id,
            message: response === null || response === void 0 ? void 0 : response.message,
        } }, otherValues));
};
class ApplicationClient {
    getApplications() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.applications(),
            });
            return data.map((a) => ({
                id: a.id,
                applicationCategory: a.application_category
                    ? (0, exports.mapApplicationCategoryResponse)(a.application_category)
                    : null,
                applicationCategoryId: a.application_category_id,
                currentDeploymentId: a.current_deployment_id,
                currentAppVersion: (0, exports.mapApplicationVersionResponse)(a.current_app_version),
                isDeprecated: a.is_deprecated,
                isMarketplace: a.is_marketplace,
                resource: (0, ResourceClient_1.mapResourceResponse)(a.resource),
                name: a.name,
                websiteUrl: a.website_url,
            }));
        });
    }
    getApplicationVersions(applicationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.applicationVersions(applicationId),
            });
            return data.map(exports.mapApplicationVersionResponse);
        });
    }
    createApplication(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.applications(),
                body: {
                    name: params.name,
                },
            });
            return (0, exports.mapApplicationResponse)(data);
        });
    }
    updateApplication(id, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.application(id),
                body: {
                    current_deployment_id: params.currentDeploymentId,
                },
            });
            return (0, exports.mapApplicationResponse)(data);
        });
    }
    createApplicationVersion(applicationId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.applicationVersions(applicationId),
                body: {
                    name: params.name,
                    major_version: params.majorVersion,
                    minor_version: params.minorVersion,
                    patch_version: params.patchVersion,
                    description: params.description,
                    icon_url: params.iconUrl,
                    thumbnail_url: params.thumbnailUrl,
                    embedded_url_format: params.embeddedUrlFormat,
                    presentation_properties: params.presentationProperties,
                    preview_orientation: params.previewOrientation,
                    preview_resolution: params.previewResolution,
                    strings: params.strings,
                    configurable_duration: params.configurableDuration,
                    default_duration: params.defaultDuration,
                    has_dynamic_thumbnails: params.hasDynamicThumbnails,
                    helper_link_text: params.helperLinkText,
                    helper_link_url: params.helperLinkUrl,
                    scopes: params.scopes,
                },
            });
            return (0, exports.mapApplicationVersionResponse)(response);
        });
    }
    getMarketPlaceApplications() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.marketPlaceApplications(),
            });
            return response.map(exports.mapApplicationResponse);
        });
    }
    sendMarketPlaceInquiry(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.sendMarketPlaceInquiry(),
                body: params,
            });
            return data;
        });
    }
    getProductList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getProductList(params.grant_scope),
            });
            return mapGetProductListResponse(response);
        });
    }
    getEXLicenses() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.getEXLicenses(),
            });
            return mapGetProductListResponse(response);
        });
    }
    purchaseProduct(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.purchaseProduct(),
                body: data,
            });
            return mapPurchaseProductResponse(response);
        });
    }
    generateApplicationVersionToken(applicationVersionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.applicationVersionToken(applicationVersionId),
            });
            return response.token;
        });
    }
}
exports.default = ApplicationClient;
